import { useEffect, useState } from "react";

export default function ProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const p = height > 0 ? (window.scrollY / height) * 100 : 0;
      setProgress(p);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 w-full z-[60] pointer-events-none"
      style={{ height: 3 }}
      data-testid="scroll-progress-bar"
    >
      <div
        className="h-full transition-[width] duration-75 ease-linear"
        style={{
          width: `${progress}%`,
          background: "linear-gradient(90deg, #0D47A1, #00897B)",
        }}
      />
    </div>
  );
}
